import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/staylinked': {
    width: 440,
    height: 512,
    paths: [
      {
        d: 'M201.6 127.4C205.7 124.2 211.9 124.4 215.4 127.9L385.4 295.2 382.7 292.5 427 333.8C430.7 337.3 430.3 342.8 426.3 346L228.3 509.9C218.4 517.5 211 510.7 211 510.7L2.3 314.6C-1.2 311.1-0.7 305.6 3.5 302.4L49.3 267.5C53.5 264.3 59.7 264.5 63.2 268L215.1 415.5C218.8 419 225.1 419.2 229.3 415.9L322.5 341.9C326.6 338.7 327 333.2 323.4 329.7L239.4 248.4C235.8 244.9 229.5 244.7 225.4 247.9L225.3 248C221.2 251.2 214.9 251 211.3 247.5L143.2 183.2C139.7 179.7 140.1 174.2 144.3 171L201.6 127.4M216.4 384.7C220.1 388.2 226.5 388.4 230.7 385.1L280.9 346.3 280.6 346 288.3 340C292.5 336.8 292.9 331.3 289.2 327.8L232.1 273.4C228.5 269.9 222.1 269.7 217.9 272.9L217.8 273C213.6 276.2 207.3 276.1 203.6 272.6L109 180.8C105.4 177.3 105.9 171.9 110.1 168.6L202.3 97.1C206.4 93.9 212.6 94.1 216.2 97.6L376.6 256.6C380.3 260.1 386.6 260.3 390.7 257.1L436.5 221.3C440.6 218.1 440.9 212.6 437.2 209.1L226.7 2.5C225.2 1.3 218.7-3 210.4 3.6L3.6 165.7C-0.6 168.9-1.2 174.4 2.4 177.9L44.7 219.6'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/staylinked.js
// module id = /1mA
// module chunks = 144